<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Cirurgia e/ou internação"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.descricao"
                        label="Descrição"
                        v-model="model.descricao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area
                        title="Realizada em"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="5">
                                <rkm-form-date-picker
                                    :max-date="data.additionals.dataAtual"
                                    :min-date="data.additionals.paciente.dataNascimento"
                                    @input="handleRealizadaEmDataInput"
                                    label="Data"
                                    v-model="model.realizadaEmData"
                                />
                            </rkm-col>

                            <rkm-col>
                                <rkm-form-input
                                    :validations="validations.realizadaEmAno"
                                    @change="handleRealizadaEmAnoChange"
                                    label="Ano(s)"
                                    number
                                    v-model="model.realizadaEmAno"
                                />
                            </rkm-col>

                            <rkm-col>
                                <rkm-form-input
                                    :validations="validations.realizadaEmMes"
                                    @change="handleRealizadaEmMesChange"
                                    label="Mês(es)"
                                    number
                                    v-model="model.realizadaEmMes"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="4"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

// Others.
import moment from 'moment'

export default {
    computed: {
        validations() {
            return {
                realizadaEmAno: {max: 3},
                realizadaEmMes: {
                    max: 2,
                    max_value: 11,
                },
                descricao: {required: true},
                observacao: {max: 500},
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            descricao: null,
            realizadaEmData: null,
            realizadaEmAno: null,
            realizadaEmMes: null,
            observacao: null,
        },
        others: {moment},
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                descricao: this.item.descricao,
                realizadaEmData: this.item.realizadaEm ? this.others.moment(this.item.realizadaEm.data, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                realizadaEmMes: this.item.realizadaEm ? this.item.realizadaEm.mes : null,
                realizadaEmAno: this.item.realizadaEm ? this.item.realizadaEm.ano : null,
                observacao: this.item.observacao,
            })
        },
        store() {
            this.data.model.cirurgiasInternacoes.push({
                descricao: this.model.descricao,
                realizadaEm: this.model.realizadaEmData ? {
                    data: this.others.moment(this.model.realizadaEmData).format('DD/MM/YYYY'),
                    ano: this.model.realizadaEmAno,
                    mes: this.model.realizadaEmMes,
                } : null,
                observacao: this.model.observacao,
            })
        },
        update() {
            Object.assign(this.item, {
                descricao: this.model.descricao,
                realizadaEm: this.model.realizadaEmData ? {
                    data: this.others.moment(this.model.realizadaEmData).format('DD/MM/YYYY'),
                    ano: this.model.realizadaEmAno,
                    mes: this.model.realizadaEmMes,
                } : null,
                observacao: this.model.observacao,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.descricao = null
            this.model.realizadaEmData = null
            this.model.realizadaEmAno = null
            this.model.realizadaEmMes = null
            this.model.observacao = null
        },
        handleRealizadaEmDataInput(value) {
            const dataSelecionada = this.others.moment(value)
            const dataNascimento = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')

            const anos = dataSelecionada.diff(dataNascimento, 'years')
            const meses = dataSelecionada.diff(dataNascimento, 'months')

            this.model.realizadaEmAno = anos
            this.model.realizadaEmMes = meses % 12
        },
        handleRealizadaEmAnoChange(value) {
            this.model.realizadaEmData = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')
                .add(value, 'years')
                .add(this.model.realizadaEmMes, 'months')
                .format('YYYY-MM-DD')
        },
        handleRealizadaEmMesChange(value) {
            this.model.realizadaEmData = this.others.moment(this.data.additionals.paciente.dataNascimento, 'DD/MM/YYYY')
                .add(this.model.realizadaEmAno, 'years')
                .add(value, 'months')
                .format('YYYY-MM-DD')
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
}
</script>